import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.auth/usergroups/usergroup-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import UserPicker from 'emun.auth/users/user-picker'
import ServiceBus from "servicestack/service-bus";

class UserGroupEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.usergroupId;
		$ctrl.bus = new ServiceBus();
		if (id == "create") {
			$ctrl.usergroup = { id: "create" };
		} else {
			let options = {
				url: "QueryUserGroups.json?Id=" + id,
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.usergroup = args.first;
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
		$ctrl.users = new AutoQuery({
			url: "QueryUsers.json",
			criteria: {
				UsergroupId: id
			},
			autoLoad: true
		});
		$ctrl.access = new AutoQuery({
			url: "QueryUsers.json",
			criteria: {
				UsergroupAccess: id
			},
			autoLoad: true
		});
	}
	submit(close) {
		const $ctrl = this;
		const action = `${$ctrl.usergroup.id == "create" ? "Cre" : "Upd"
			}ateUserGroup.json`;

		return $ctrl.bus.send(action, $ctrl.usergroup).then((res) => {
			$ctrl.usergroup.id = res.data.id;
			$ctrl.users.criteria.UsergroupId = $ctrl.usergroup.id;
			if (close) resolve("$state").go("usergroup-list");
		});
	}

	addUser() {
		let $ctrl = this;
		$ctrl.userIds = [];

		return UserPicker({
			title: "Select Users...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddUserGroupUsers", {
					UsergroupId: $ctrl.usergroup.id,
					UserIds: result
				}).then(function (response) {
					$ctrl.users.load();
				});
			});
		});
	}
	addAccess() {
		let $ctrl = this;
		$ctrl.accessIds = [];

		return UserPicker({
			title: "Select Users...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.submit().then(function (res) {
				$ctrl.bus.send("AddUserGroupAccess", {
					UsergroupId: $ctrl.usergroup.id,
					UserIds: result
				}).then(function (response) {
					$ctrl.access.load();
				});
			});
		});
	}
	deleteUser(user) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + user.salesRepId + " - " + user.displayName, "Remove User?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteUserGroupUser.json", {
						UsergroupId: $ctrl.usergroup.id,
						UserId: user.salesRepId
					})
					.then(function () {
						return $ctrl.users.load(true);
					})
					.catch(

					);
			});
	}
	deleteAccess(user) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + user.salesRepId + " - " + user.displayName, "Remove Access?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteUserGroupAccess.json", {
						UsergroupId: $ctrl.usergroup.id,
						UserId: user.salesRepId
					})
					.then(function () {
						return $ctrl.access.load(true);
					})
					.catch(

					);
			});
	}

}

let UserGroupEdit = {
	controller: UserGroupEditController,
	bindings: {
		usergroupId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default UserGroupEdit;
